<div [innerHTML]="sanitizedContent"></div>